import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/HomePage.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { path: '/', name: 'home', component: Home },
    // { path: '/about', name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    // },

    {
      path: '/o-mnie',
      name: 'about',
      component: () => import('./views/AboutPage.vue'),
    },
    {
      path: '/kontakt',
      name: 'contact',
      component: () => import('./views/ContactPage.vue'),
    },
    {
      path: '/galeria',
      name: 'galleries',
      component: () => import('./views/GalleriesPage.vue'),
    },
    {
      path: '/galeria/:slug',
      name: 'gallery',
      component: () => import('./views/GalleryPage.vue'),
    },
    {
      path: '/uslugi',
      name: 'services',
      component: () => import('./views/ServicesPage.vue'),
    },
    {
      path: '/oferta',
      name: 'offer',
      component: () => import('./views/OfferPage.vue'),
    },
    {
      path: '/realizacje',
      name: 'projects',
      component: () => import('./views/ProjectsPage.vue'),
    },
    {
      path: '/zamowienia',
      name: 'orders',
      component: () => import('./views/OrdersPage.vue'),
    },
    {
      path: '/ciasteczka',
      name: 'cookies',
      component: () => import('./views/CookiesPage'),
    },
    {
      path: '/projectanci',
      name: 'designers',
      component: () => import('./views/DesignersPage.vue'),
    },
  ],
});
